<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="loading d-flex justify-content-center align-items-center">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  computed: {
    currentUser(){
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    if(!this.currentUser) {
      this.$router.push('/login');
    }else{
      this.$router.push('/dash');
    }
  }
}
</script>
<style scoped>
.home{
  height: 100vh;
}
.home .loading{
  height: 100vh;
}
</style>
